webpackJsonp([27253921027855],{

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LogoSliderComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(11);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _reactAliceCarousel = __webpack_require__(12);
	
	var _reactAliceCarousel2 = _interopRequireDefault(_reactAliceCarousel);
	
	var _CompanyLogos = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var responsive = {
	    0: {
	        items: 2
	    },
	    320: {
	        items: 2
	    },
	    550: {
	        items: 3
	    },
	    768: {
	        items: 4
	    },
	    1024: {
	        items: 4
	    },
	    1260: {
	        items: 5
	    },
	    1460: {
	        items: 5
	    },
	    3000: {
	        items: 5
	    }
	};
	
	var LogoSliderComponent = exports.LogoSliderComponent = function (_React$Component) {
	    _inherits(LogoSliderComponent, _React$Component);
	
	    function LogoSliderComponent() {
	        _classCallCheck(this, LogoSliderComponent);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    LogoSliderComponent.prototype.galleryItems = function galleryItems() {
	        return _CompanyLogos.imageList.map(function (item) {
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement('img', { src: item })
	            );
	        });
	    };
	
	    LogoSliderComponent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'company-logos' },
	            _react2.default.createElement(_reactAliceCarousel2.default, { autoPlay: true, autoPlayInterval: 2500, duration: 400, responsive: responsive, items: this.galleryItems() })
	        );
	    };
	
	    return LogoSliderComponent;
	}(_react2.default.Component);
	
	var ListItem = function (_Component) {
	    _inherits(ListItem, _Component);
	
	    function ListItem() {
	        _classCallCheck(this, ListItem);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ListItem.prototype.render = function render() {
	        var _props$itemData = this.props.itemData,
	            name = _props$itemData.name,
	            image = _props$itemData.image,
	            sub_title = _props$itemData.sub_title,
	            description = _props$itemData.description,
	            url = _props$itemData.url,
	            highlight = _props$itemData.highlight;
	
	        return _react2.default.createElement(
	            'li',
	            { className: highlight ? 'highlight' : '' },
	            _react2.default.createElement(
	                'div',
	                { className: 'list' },
	                _react2.default.createElement('img', { src: image }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        name
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'sub_title' },
	                        sub_title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'des' },
	                        description
	                    )
	                )
	            )
	        );
	    };
	
	    return ListItem;
	}(_react.Component);
	
	var MainPage = function (_Component2) {
	    _inherits(MainPage, _Component2);
	
	    function MainPage() {
	        _classCallCheck(this, MainPage);
	
	        return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	    }
	
	    MainPage.prototype.render = function render() {
	        var _props$data = this.props.data,
	            landing_image = _props$data.landing_image,
	            about = _props$data.about,
	            aboutPara = _props$data.aboutPara,
	            infoList = _props$data.infoList;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'main-page fit-pages' },
	            _react2.default.createElement(
	                'div',
	                { className: 'landing-page' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'The only digital transformation that your sales team will ever need.'
	                    )
	                ),
	                _react2.default.createElement('img', { src: landing_image })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'products' },
	                _react2.default.createElement(LogoSliderComponent, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'head' },
	                    about
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'para' },
	                    aboutPara
	                )
	            ),
	            _react2.default.createElement(_List2.default, { items: infoList, listItem: ListItem, className: 'info-list-cls' })
	        );
	    };
	
	    return MainPage;
	}(_react.Component);
	
	exports.default = MainPage;

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fitSalesData = undefined;
	
	var _group152x = __webpack_require__(846);
	
	var _group152x2 = _interopRequireDefault(_group152x);
	
	var _leave2x = __webpack_require__(851);
	
	var _leave2x2 = _interopRequireDefault(_leave2x);
	
	var _attendance2x = __webpack_require__(842);
	
	var _attendance2x2 = _interopRequireDefault(_attendance2x);
	
	var _contactMngmt2x = __webpack_require__(844);
	
	var _contactMngmt2x2 = _interopRequireDefault(_contactMngmt2x);
	
	var _missionMngmtVig2x = __webpack_require__(853);
	
	var _missionMngmtVig2x2 = _interopRequireDefault(_missionMngmtVig2x);
	
	var _claim2x = __webpack_require__(843);
	
	var _claim2x2 = _interopRequireDefault(_claim2x);
	
	var _dashboard2x = __webpack_require__(845);
	
	var _dashboard2x2 = _interopRequireDefault(_dashboard2x);
	
	var _leaderboard2x = __webpack_require__(850);
	
	var _leaderboard2x2 = _interopRequireDefault(_leaderboard2x);
	
	var _integrations2x = __webpack_require__(848);
	
	var _integrations2x2 = _interopRequireDefault(_integrations2x);
	
	var _leadManagement2x = __webpack_require__(849);
	
	var _leadManagement2x2 = _interopRequireDefault(_leadManagement2x);
	
	var _locationManagementfinal2x = __webpack_require__(852);
	
	var _locationManagementfinal2x2 = _interopRequireDefault(_locationManagementfinal2x);
	
	var _incentives2x = __webpack_require__(847);
	
	var _incentives2x2 = _interopRequireDefault(_incentives2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fitSalesData = exports.fitSalesData = {
	    landing_image: _group152x2.default,
	    about: 'Hubler brings you a suite of easy-to-use and customizable apps.',
	    aboutPara: 'No more exhausted sales execs. No more lost leads. No more broken computer screens or screaming employees.\n' + 'From leads & customer engagement, to on-field workforce management, to actionable insights and reports.' + ' Imagine everything aligned, on one platform.\n' + 'Here’s what Hubler does for you…',
	    infoList: [{
	        id: '1',
	        name: 'All customers’ insights, at your fingertips',
	        image: _contactMngmt2x2.default,
	        sub_title: 'Customers & contacts management',
	        url: '',
	        description: 'From important information of your customers, to leads pipelines & status of closures and progress tracking…all organized and made sense of…smoothen your sales process with just a few clicks.'
	    }, {
	        id: '2',
	        name: 'Manage your Leads, your way',
	        image: _leadManagement2x2.default,
	        sub_title: 'Leads & opportunities',
	        url: '',
	        description: 'Alright, you’ve tried 100 other lead management apps. But this one has a twist. You can customize it to align to your organisation’s processes. Capture critical customer data - view pipelines according to your products, services, and more. All in real-time.'
	    }, {
	        id: '3',
	        name: 'Make leaves stress-free',
	        image: _leave2x2.default,
	        sub_title: 'Leaves Management',
	        url: '',
	        description: 'Alarmed at field guys taking sudden leaves? Hubler makes it easy for your to plan when your employees take an off-day. Assign leave limits to plan and manage better - never be caught without your army.'
	    }, {
	        id: '4',
	        name: 'Let everyone know the big picture',
	        image: _missionMngmtVig2x2.default,
	        sub_title: 'Missions and goals',
	        url: '',
	        description: 'Arm your teams with real-time goal tracking. Give your workforce a clear visibility of goals they need to work for. If your employees know exactly what to do next, work is no longer work.'
	    }, {
	        id: '5',
	        name: 'Know where the action is, in real-time',
	        image: _locationManagementfinal2x2.default,
	        sub_title: 'Locations and remote check-ins',
	        url: '',
	        description: 'Increase business intelligence with live location updates of your field sales execs. You can review client check-ins, and record the locations of positive engagement. Make remote-working possible anytime with just a click.'
	    }, {
	        id: '6',
	        name: 'Mark attendance from anywhere',
	        image: _attendance2x2.default,
	        sub_title: 'Attendance and people',
	        url: '',
	        description: 'Remove commute-time problems for your employees. Make it easy to work from anywhere - with accurate tracking of working hours. \n' + 'Also, manage shifts and region-wise profiles of employees. \n' + 'Lose no data as it is synced across all Hubler apps.'
	    }, /*{
	         id: '7',
	         name: 'Name of the case study',
	         highlight:true,
	         image:leave,
	         sub_title: 'Case Study 01',
	         url: '',
	         description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation'
	       },*/{
	        id: '8',
	        name: 'Claims treated right, without the clutter',
	        image: _claim2x2.default,
	        sub_title: 'Claims and reimbursements',
	        url: '',
	        description: 'Is your team wasting critical time just filing claims? Now they can mark claims in real-time, attach ' + 'bills on the go. You can track multiple claims’ status easily, and approve them faster. Say goodbye to the long ' + 'list of excel sheets you’re approving.'
	    }, {
	        id: '9',
	        name: 'Automate Analysis, make it actionable',
	        image: _dashboard2x2.default,
	        sub_title: 'Dashboards and insights',
	        url: '',
	        description: 'Enhance sales results with insights you want - just feed data and get automated analysis on what you want, ' + 'the dashboards will do the rest. Also, try more widgets for a complete business view of actionable business data.'
	    }, {
	        id: '10',
	        name: 'Step-up work cultures',
	        image: _leaderboard2x2.default,
	        sub_title: 'Leaderboards and recognitions',
	        url: '',
	        description: 'Make work awesome with real-time rankings of your company’s performers. Inspire workforce with regularly updating success stories in Hubler’s Leaderboard app.'
	    }, /*{
	             id: '11',
	             image:leave,
	             highlight:true,
	             name: 'Name of the case study',
	             sub_title: 'Case Study 02',
	             url: '',
	             description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation'
	         },*/
	    {
	        id: '12',
	        image: _incentives2x2.default,
	        name: 'Make examples out of top performers',
	        sub_title: 'Incentives and updates',
	        url: '',
	        description: 'Let your team know that you got their back with regular and fair appreciation. Manage a clear record of their incentives and boost your team’s morale.'
	    }, {
	        id: '13',
	        name: 'Bring out the best from all your systems',
	        image: _integrations2x2.default,
	        sub_title: 'Integrations with other apps',
	        url: '',
	        description: 'Make safer accounts and payments with tighter integration of business and service related data. ' + 'Get faster integration of financial data from apps. See smart automation adapt to your systems for progress.'
	    }]
	};

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/attendance@2x.7c8adf93.png";

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/claim@2x.8218f5e0.png";

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contact-mngmt@2x.88f83eab.png";

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dashboard@2x.017eb696.png";

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/group-15@2x.c7d0a5f9.png";

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/incentives@2x.ba85d580.png";

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/integrations@2x.d730e492.png";

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lead-management@2x.f526c8d7.png";

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/leaderboard@2x.b1a96b33.png";

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/leave@2x.8abd11b8.png";

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/location-managementfinal@2x.ff0b7c8c.png";

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mission-mngmt-vig@2x.35e52523.png";

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainPage = __webpack_require__(420);
	
	var _mainPage2 = _interopRequireDefault(_mainPage);
	
	var _fitSales = __webpack_require__(424);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sales = function (_Component) {
	    _inherits(Sales, _Component);
	
	    function Sales() {
	        _classCallCheck(this, Sales);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Sales.prototype.render = function render() {
	        return _react2.default.createElement(_mainPage2.default, { data: _fitSales.fitSalesData });
	    };
	
	    return Sales;
	}(_react.Component);
	
	exports.default = Sales;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-solutions-sales-js-88c6cdd62064df293840.js